// extracted by mini-css-extract-plugin
module.exports = {"TemplateList":"Templates_TemplateList__2u-wl","TemplateButton":"Templates_TemplateButton__1_sFF"};